import React, { FC, useState, useEffect, useContext } from 'react';
import { ProfileSection } from './ProfileSection';
import { sessionStore } from 'src/store/sessionStore';
import { useUpdateTrainerProfile } from 'src/api/mutations/useUpdateTrainerProfile';
import { ProfileEditContext } from '../ProfileEditContext';
import './TextSection.scss';
import { ReactComponent as ExpertiseIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/expertise.svg';

export const ExpertiseSection: FC = () => {
  const { currentUser } = sessionStore();
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState('');
  const [expertise, setExpertise] = useState(currentUser?.expertise || '');
  const { mutateAsync: updateProfileBackend, isPending } = useUpdateTrainerProfile();

  const { globalEditAction, registerEditState } = useContext(ProfileEditContext);

  useEffect(() => {
    if (globalEditAction.count > 0) {
      if (globalEditAction.type === 'OPEN') {
        setIsEditing(true);
      } else if (globalEditAction.type === 'CLOSE') {
        setIsEditing(false);
      }
    }
  }, [globalEditAction]);

  useEffect(() => {
    registerEditState('expertise', isEditing);
  }, [isEditing, registerEditState]);

  useEffect(() => {
    if (currentUser && !isEditing) {
      setExpertise(currentUser.expertise || '');
    }
  }, [currentUser, isEditing]);

  const handleSave = async () => {
    if (!currentUser) return;

    if (expertise.length > 1000) {
      setError('Expertise must be less than 1000 characters');
      return;
    }

    const trimmedExpertise = expertise.trim();
    if (!trimmedExpertise) {
      setError('Expertise is required');
      return;
    }
    setError('');
    setExpertise(trimmedExpertise);

    try {
      const uid = currentUser?.uid || '';
      await updateProfileBackend({
        uid,
        data: { expertise: trimmedExpertise },
      });
      setIsEditing(false);
    } catch (error) {
      console.error(error);
    }
  };

  const viewContent = (
    <div className="text-section-view">
      <div className="icon-wrapper">{<ExpertiseIcon />}</div>
      <p>{currentUser?.expertise || 'No expertise description provided.'}</p>
    </div>
  );

  const editContent = (
    <div className="text-section-edit">
      <p className="description">{'Describe your areas of expertise and what makes you unique'}</p>
      <div className="form-group">
        <textarea
          value={expertise}
          maxLength={1000}
          onChange={(e) => {
            setExpertise(e.target.value);
            if (error) setError('');
          }}
          onBlur={(e) => setExpertise(e.target.value.trim())}
          placeholder="Specialized in strength training and functional fitness..."
          className={error ? 'error-border' : ''}
        />
        {error && <p className="error-message">{error}</p>}
        <small
          style={{
            color: expertise.length > 1000 ? 'red' : 'rgba(255,255,255,0.4)',
            alignSelf: 'flex-end',
            marginTop: 4,
          }}
        >
          {expertise.length}/1000
        </small>
      </div>
    </div>
  );

  return (
    <ProfileSection
      title="Expertise"
      className="align-items-center career-highlights-centificate-header"
      isEditing={isEditing}
      isSaving={isPending}
      onEditToggle={setIsEditing}
      onSave={handleSave}
      onCancel={() => {
        if (currentUser) {
          setExpertise(currentUser.expertise || '');
          setError('');
        }
      }}
      editContent={editContent}
    >
      {viewContent}
    </ProfileSection>
  );
};
